import React from 'react';
import {Route, Routes} from "react-router-dom";
import AttributeDetailsScreen from "./attributeDetails";
import AttributeListScreen from "./attributeList";


const AttributesRoutes = () => {
    return (
        <Routes>
            <Route path="/:attributeId/*" element={<AttributeDetailsScreen />} />
            <Route path="/" element={<AttributeListScreen/>} />
        </Routes>
    );
}

export default AttributesRoutes;
